import React, {useState} from "react";
import {Proposal, ProposalItem} from "../../models/proposal/Proposal";
import {useLocation} from "react-router-dom";
import DocumentViewer from "../../components/DocumentViewer";
import {Box, Button, Container, FormControl, Stack, TextField} from "@mui/material";
import {Add} from "@mui/icons-material";
import {Configuration} from "../../Configuration";
import {AuthContextProps, useAuth} from "react-oidc-context";
import {CustomPromptRequest} from "../../models/customprompt/CustomPromptRequest";
import {CustomPromptResponse} from "../../models/customprompt/CustomPromptResponse";
import CircularProgress from "@mui/material/CircularProgress";


const ResultEdit = () => {
    const auth = useAuth();
    const location = useLocation();
    // location.state as ProposalItem
    const originalProposalItem = location.state as ProposalItem;
    const [proposalItem, setProposalItem] = useState<ProposalItem>(location.state as ProposalItem);
    const [promptText, setPromptText] = useState<string>("");
    const [isGenerating, setIsGenerating] = useState<boolean>(false);

    const handlePromptTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPromptText(e.target.value);
    }

    const processPrompt = async () => {
        const baseApiUrl = Configuration.customPromptApiBaseUrl;
        
        setIsGenerating(true);
        
        let authContextProps= auth as AuthContextProps;
        let request = new CustomPromptRequest();
        request.prompt = promptText;
        request.proposalItemUniqueId = originalProposalItem.uniqueId;
        request.proposalText = proposalItem.result;
        const response = await fetch(`${baseApiUrl}/generate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${authContextProps.user?.access_token}`,
            },
            body: JSON.stringify(request),
        });
        
        setIsGenerating(false);
        
        if (response.status !== 200) {
            alert("Error retrieving proposals: " + response.status);
            return;
        }

        let result = await response.json() as CustomPromptResponse;
        
        setProposalItem({... proposalItem, result: result.response});
    };
    
    return (
        <Container maxWidth="lg" sx={{mt: 4, mb: 4}} >
            <Stack direction="row" spacing={2}>
                <Box sx={{flex: "2 1", maxWidth: "66%"}}>
                    { isGenerating 
                        ? <CircularProgress />
                        : <DocumentViewer
                            proposalItem={proposalItem}
                            allowDownload={true}
                            allowEdit={false}/>
                    } 
                </Box>
                <Stack
                    sx={{flex: "2 1", maxWidth: "33%"}}>
                    <FormControl>
                        <TextField
                            fullWidth
                            multiline
                            rows={4}
                            variant="outlined"
                            value={promptText}
                            onChange={handlePromptTextChange}
                            placeholder="Voer hier de nieuwe prompt in..."
                            disabled={isGenerating}
                        />
                    </FormControl>
                    <Button
                        variant="contained"
                        startIcon={<Add/>}
                        sx={{mb: 3}}
                        disabled={isGenerating}
                        onClick={processPrompt}>Tekst aanpassen</Button>
                </Stack>
            </Stack>
        </Container>
    )
}

export default ResultEdit;